import { useState } from 'react'
import { useBets } from '@hooks/queries/useBets'
import FreebetsList from './FreebetsList'

const PAGE_SIZE = 15

// Generic bets-history tab. Reads the shared bets query (same as "My
// Transactions", 1-indexed) with the given filters and renders each row with the
// given Card. Used for both Freebet History (subType FREEBET) and Purchases
// (type PURCHASE) — the tab is pure plumbing; filters + Card decide the rest.
const BetsHistoryTab = ({ filters, headerElements, Card, emptyMessage }) => {
  const [currentPage, setCurrentPage] = useState(1)

  const { data, isPending, isError } = useBets({ ...filters, page: currentPage, pageSize: PAGE_SIZE })
  const rows = data?.rows ?? []

  return (
    <FreebetsList
      headerElements={headerElements}
      rows={rows}
      renderCard={(row, index) => <Card key={row.id ?? index} data={row} />}
      isPending={isPending}
      isError={isError}
      emptyMessage={emptyMessage}
      total={data?.total}
      pageSize={PAGE_SIZE}
      currentPage={currentPage}
      onPageChange={setCurrentPage}
    />
  )
}

export default BetsHistoryTab
